import React from 'react';
import { FormattedNumber } from 'react-intl';
import CurrentPrice from './CurrentPrice';
import commerceUtils from '../../../services/commerceUtils';
import PriceContainer from './PriceContainer';
import InitialPrice from './InitialPrice';
import PriceLabel from './PriceLabel';
import YouSave from './YouSave';

var PriceTag = function PriceTag(_ref) {
  var price = _ref.price,
      discount = _ref.discount,
      currency = _ref.currency;
  var savedAmount = price - commerceUtils.minusPercent(price, discount);
  var renderPrice = discount ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CurrentPrice, null, /*#__PURE__*/React.createElement(FormattedNumber, {
    value: commerceUtils.minusPercent(price, discount),
    style: "currency" // eslint-disable-line react/style-prop-object
    ,
    currency: currency,
    minimumFractionDigits: 2
  })), /*#__PURE__*/React.createElement(InitialPrice, null, /*#__PURE__*/React.createElement(FormattedNumber, {
    value: price,
    style: "currency" // eslint-disable-line react/style-prop-object
    ,
    currency: currency,
    minimumFractionDigits: 2
  }))) : /*#__PURE__*/React.createElement(CurrentPrice, null, /*#__PURE__*/React.createElement(FormattedNumber, {
    value: price,
    style: "currency" // eslint-disable-line react/style-prop-object
    ,
    currency: currency,
    minimumFractionDigits: 2
  }));
  return /*#__PURE__*/React.createElement(PriceContainer, null, /*#__PURE__*/React.createElement(PriceLabel, null, renderPrice), !!discount && /*#__PURE__*/React.createElement(YouSave, {
    savedAmount: savedAmount,
    discount: discount,
    currency: currency
  }));
};

PriceTag.defaultProps = {
  discount: 0
};
export default PriceTag;